import { render, staticRenderFns } from "./SavedTripCard.vue?vue&type=template&id=608c6d78"
import script from "./SavedTripCard.vue?vue&type=script&lang=ts"
export * from "./SavedTripCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports